module.exports = __webpack_public_path__ + "static/img/login_img.a25acff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layout/login_img.png
// module id = RRCe
// module chunks = 1